/**
 * 図書館画面の上部タブ (検索結果 / 候補 / 予約中) と URL クエリ (?tab=) の対応。
 *
 * 履歴 (returned) は見る頻度が低いためタブには置かず、ヘッダーメニューのシートで開く。
 */

import type { LibraryFavoriteStatus } from '@/api/types/library-favorite'
import type { QueryCodec } from '@/hooks/useQueryState'

export type LibraryTab = 'search' | Extract<LibraryFavoriteStatus, 'wishlist' | 'reserved'>

export const LIBRARY_TABS = ['search', 'wishlist', 'reserved'] as const satisfies readonly LibraryTab[]

const DEFAULT_TAB: LibraryTab = 'search'

// 旧 UI の「お気に入り」タブ (?tab=favorites) は候補を初期表示していたので、候補タブとして開く
const LEGACY_TAB_ALIASES = new Map<string, LibraryTab>([['favorites', 'wishlist']])

export const libraryTabCodec: QueryCodec<LibraryTab> = {
  parse: (raw) => LIBRARY_TABS.find((tab) => tab === raw) ?? LEGACY_TAB_ALIASES.get(raw ?? '') ?? DEFAULT_TAB,
  serialize: (value) => value,
  defaultValue: DEFAULT_TAB,
}
